const gql = require("graphql-tag");

const ROLE_DELETE = gql`
  mutation($data: RoleRemoveInput!) {
    roleRemove(data: $data) {
      n
      deletedCount
      ok
    }
  }
`;

const ROLE_PARENT_DELETE = gql`
  mutation($data: RoleParentRemoveInput!) {
    RoleParentRemoveInput(data: $data) {
      n
      deletedCount
      ok
    }
  }
`;

const PERSON_CREATE = gql`
  mutation($data: PersonInput!) {
    personCreate(data: $data) {
      id
      isActive
      createdAt
      type
      roleUser {
        id
        username
        name
        surname
        isActive
      }
      company {
        id
        name
        description
        isActive
      }
    }
  }
`;

const PERSON_UPDATE = gql`
  mutation($data: PersonUpdateInput!) {
    personUpdate(data: $data) {
      n
      nModified
      ok
    }
  }
`;

export const rolesMutations = {
  ROLE_DELETE,
  ROLE_PARENT_DELETE,
  PERSON_CREATE,
  PERSON_UPDATE,
};
